import TokenService from "./token.service";
import StorageService from '@services/storage.service';
import router from "@/router";
import store from "@/store";

const ApiService = {
  interceptorSetup: false,

  init(baseURL) {
    axios.defaults.baseURL = baseURL;
    this.setupInterceptors();
  },

  setupInterceptors() {
    // Only setup interceptors once
    if (this.interceptorSetup) {
      return;
    }

    // Response interceptor for handling 401 errors
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          const errorData = error.response.data;



          // Check if the error message contains "Unauthenticated" (with or without period)
          if (
            errorData.message?.includes('Unauthenticated') ||
            errorData.status === 401
          ) {
            // Save current locale before clearing storage
            const currentLocale = localStorage.getItem("locale");

            // Remove user from storage
            StorageService.removeItem("user");
            StorageService.removeItem("role");
            StorageService.removeItem("roles");
            StorageService.removeItem("permissions");
            StorageService.removeItem("superadminLoggedSchool");
            StorageService.removeItem("districtLoggedSchool");

            // Clear storage but preserve locale
            StorageService.clean();

            // Restore locale if it existed
            if (currentLocale) {
              localStorage.setItem("locale", currentLocale);
            }

            // Remove token from storage
            TokenService.removeToken();
            TokenService.removeRefreshToken();

            // Remove token from header
            this.removeAuthHeader();

            // Clear Vuex store
            store.commit("users/logout");

            // Remove cookie
            document.cookie = 'access_token=; path=/; max-age=-1; SameSite=Lax';

            // Redirect to login page
            window.location.reload();

            console.warn("Session expired. Redirecting to login...");
          }
        }

        return Promise.reject(error);
      }
    );

    this.interceptorSetup = true;
  },

  setHeader(key, value) {
    axios.defaults.headers.common[key] = value;
  },

  getHeader(key) {
    return axios.defaults.headers.common;
  },

  setDefaultHeaders() {
    let locale = Vue.Lang.getLocale();
    this.setHeader("X-Requested-With", "XMLHttpRequest");
    this.setHeader("X-CSRF-TOKEN", CSRFtoken);
    this.setHeader("Accept", "application/json");
    this.setHeader("SMS-Locale", locale);
  },

  setAuthHeader() {
    const token = TokenService.getToken();
    this.setHeader("Authorization", `Bearer ${token}`);
    document.cookie = `access_token=${token}; path=/; max-age=120; SameSite=Lax`;
  },

  setHeaders(headers) {
    this.setDefaultHeaders();
    for (let header in headers) {
      axios.defaults.headers.common[header] = headers[header];
    }
  },

  removeHeader(key) {
    delete axios.defaults.headers.common[key];
  },

  removeAuthHeader() {
    this.removeHeader("Authorization");
    document.cookie = 'access_token=; path=/; max-age=-1; SameSite=Lax';
  },

  clearHeaders() {
    axios.defaults.headers.common = {}
    document.cookie = 'access_token=; path=/; max-age=-1; SameSite=Lax';
  },

  get(resource, params = null, headers = {}) {
    return axios.get(resource, {
      params: params,
      headers: headers
    })
  },

  getBlob(resource, params = null, config = {}) {
    return axios.get(resource, {
      params: params,
      ...config,
      responseType: 'blob'
    })
  },

  post(resource, data, config = {}) {
    return axios.post(resource, data, config)
  },

  put(resource, data) {
    return axios.put(resource, data)
  },

  delete(resource, params = null) {
    return axios.delete(resource, {
      params: params
    })
  },

  customRequest(data) {
    return axios(data)
  }
}

export default ApiService